import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWeb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 24,
	viewBox: "0 0 26 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Globalization.CtzBPdss_Zn58LE.svg",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Clip path group",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_3292_15114",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 1,
				y: 0,
				width: 24,
				height: 24,
				children: /* @__PURE__ */ _jsx("g", {
					id: "a",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M25 0H1V24H25V0Z",
						fill: "white"
					})
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_3292_15114)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_2",
							d: "M18.0486 6.62891C16.6801 6.91464 15.2139 7.08379 13.7031 7.12401V11.2967H18.6487C18.6031 9.65316 18.3981 8.07306 18.0486 6.62891Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_3",
							d: "M5.94424 11.2966C5.99061 9.54246 6.2101 7.84957 6.58627 6.29571C5.35439 5.94992 4.22729 5.50287 3.24984 4.96558C1.91107 6.81295 1.13197 8.99354 1 11.2966H5.94424Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_4",
							d: "M5.94424 12.7031H1C1.13197 15.0062 1.91107 17.1868 3.24979 19.0342C4.22725 18.4969 5.35439 18.0498 6.58627 17.704C6.2101 16.1502 5.99056 14.4573 5.94424 12.7031Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_5",
							d: "M15.0222 0.8126C14.5922 0.448855 14.1506 0.203811 13.7031 0.078125V5.71746C15.084 5.67902 16.4198 5.5276 17.6652 5.27444C17.4366 4.57592 17.171 3.91983 16.8696 3.31709C16.3281 2.23425 15.7066 1.39157 15.0222 0.8126Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_6",
							d: "M6.96377 19.0559C5.93432 19.345 4.98828 19.7096 4.15723 20.1426C4.2688 20.2635 4.38244 20.383 4.49945 20.5001C5.85134 21.8519 7.46853 22.842 9.23362 23.422C8.73918 22.8376 8.2819 22.1318 7.87189 21.3117C7.52493 20.6178 7.22147 19.8614 6.96377 19.0559Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_7",
							d: "M9.13052 3.31709C8.82917 3.91983 8.5635 4.57592 8.33496 5.27444C9.58029 5.5276 10.9161 5.67902 12.297 5.71746V0.078125C11.8494 0.203858 11.408 0.448855 10.978 0.8126C10.2935 1.39157 9.67199 2.23425 9.13052 3.31709Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_8",
							d: "M20.0561 12.7031C20.0097 14.4573 19.7902 16.1502 19.4141 17.704C20.6459 18.0498 21.7731 18.4969 22.7505 19.0342C24.0893 17.1868 24.8683 15.0063 25.0003 12.7031H20.0561Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_9",
							d: "M19.0355 4.9439C20.065 4.65479 21.011 4.29025 21.842 3.85721C21.7304 3.73631 21.6169 3.61681 21.4998 3.4998C20.148 2.14795 18.5307 1.15789 16.7656 0.577881C17.2601 1.16229 17.7173 1.86808 18.1274 2.68806C18.4743 3.38199 18.7778 4.13845 19.0355 4.9439Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_10",
							d: "M16.8696 20.6826C17.171 20.0799 17.4366 19.4238 17.6652 18.7252C16.4198 18.4721 15.084 18.3207 13.7031 18.2822V23.9216C14.1507 23.7959 14.5922 23.5509 15.0222 23.1871C15.7066 22.6081 16.3282 21.7655 16.8696 20.6826Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_11",
							d: "M19.4141 6.29591C19.7902 7.84976 20.0097 9.54266 20.0561 11.2968H25.0003C24.8684 8.99374 24.0893 6.81314 22.7505 4.96582C21.7731 5.50307 20.6459 5.95012 19.4141 6.29591Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_12",
							d: "M13.7031 12.7031V16.8758C15.2139 16.916 16.68 17.0852 18.0486 17.3709C18.3981 15.9267 18.6031 14.3467 18.6487 12.7031H13.7031Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_13",
							d: "M12.2971 11.2967V7.12401C10.7863 7.08379 9.32021 6.91464 7.95168 6.62891C7.60218 8.0731 7.39713 9.65316 7.35156 11.2967H12.2971Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_14",
							d: "M6.96377 4.9439C7.22142 4.1384 7.52493 3.38199 7.87189 2.68806C8.2819 1.86808 8.73918 1.16225 9.23362 0.577881C7.46858 1.15789 5.85134 2.14795 4.49945 3.49984C4.38244 3.61686 4.2688 3.73635 4.15723 3.85726C4.98828 4.29025 5.93432 4.65479 6.96377 4.9439Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_15",
							d: "M19.0355 19.0559C18.7778 19.8614 18.4743 20.6178 18.1274 21.3117C17.7173 22.1317 17.2601 22.8376 16.7656 23.422C18.5307 22.842 20.1479 21.8519 21.4998 20.5001C21.6168 20.383 21.7304 20.2635 21.842 20.1426C21.011 19.7096 20.0649 19.345 19.0355 19.0559Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_16",
							d: "M12.2971 12.7031H7.35156C7.39713 14.3467 7.60218 15.9268 7.95168 17.3709C9.32016 17.0852 10.7863 16.916 12.2971 16.8758V12.7031Z",
							fill: "#0587FB"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_17",
							d: "M10.978 23.1873C11.408 23.5511 11.8495 23.7961 12.297 23.9218V18.2825C10.9161 18.3209 9.58029 18.4723 8.33496 18.7255C8.5635 19.424 8.82913 20.0801 9.13052 20.6829C9.67199 21.7657 10.2935 22.6083 10.978 23.1873Z",
							fill: "#0587FB"
						})
					]
				})
			})]
		})
	})
});
export default SvgIconWeb;
